var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEggPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82449 7.64062L4.00097 7.6431L4.68648 7.92259L6.4732 9.65023L6.3355 12.3336L3.60181 9.69027L1.82227 9.68825L1.82449 7.64062Z",
    fill: "#208C72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.4644C9 22.3126 8.32843 23.0001 7.5 23.0001C6.67157 23.0001 6 22.3126 6 21.4644C6 20.6163 6.67157 19.9287 7.5 19.9287C8.32843 19.9287 9 20.6163 9 21.4644Z",
    fill: "#208C72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9985 21.4644C18.9985 22.3126 18.327 23.0001 17.4985 23.0001C16.6701 23.0001 15.9985 22.3126 15.9985 21.4644C15.9985 20.6163 16.6701 19.9287 17.4985 19.9287C18.327 19.9287 18.9985 20.6163 18.9985 21.4644Z",
    fill: "#208C72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1054 6.28794C7.97046 8.05589 7.16178 10.4279 7.02079 12.7621C6.8823 15.0549 7.49346 16.5425 8.42119 17.4651C9.36634 18.4051 10.7867 18.9048 12.5288 18.9048C14.2713 18.9048 15.6842 18.4049 16.6181 17.4682C17.5344 16.5491 18.1336 15.0644 17.9765 12.7705C17.8144 10.4025 17.0912 8.0175 16.0557 6.25289C14.9878 4.43314 13.7669 3.54763 12.6994 3.54763C11.6069 3.54763 10.2755 4.46525 9.1054 6.28794ZM7.43407 5.16332C8.72292 3.15561 10.578 1.5 12.6994 1.5C14.846 1.5 16.5902 3.18772 17.7701 5.19837C18.9823 7.26416 19.7895 9.96669 19.9716 12.6274C20.1588 15.3621 19.4519 17.4923 18.0177 18.9308C18.0098 18.9388 18.0018 18.9467 17.9939 18.9546C17.8342 18.9219 17.669 18.9047 17.4999 18.9047C16.4167 18.9047 15.4944 19.61 15.1472 20.5964C14.3196 20.8397 13.4343 20.9524 12.5288 20.9524C11.601 20.9524 10.6941 20.8342 9.84781 20.5787C9.49585 19.6015 8.57814 18.9047 7.50147 18.9047C7.34443 18.9047 7.19077 18.9195 7.04175 18.9479L7.02766 18.9339C5.58469 17.4989 4.85934 15.3717 5.0246 12.6357C5.18736 9.94127 6.11006 7.22577 7.43407 5.16332Z",
    fill: "#3360AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 9.33301V14.6663",
    stroke: "#F28520",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 12L9.99967 12",
    stroke: "#F28520",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggPlus);
export default __webpack_public_path__ + "static/media/egg-plus.b55b63ed80fef7fac3664cde093f69ed.svg";
export { ForwardRef as ReactComponent };